import React from 'react';
import {Suggestions} from 'components';
import {useNamedSelector} from 'helpers';

export function Routines(props, _, extra) {
  return (
    <Suggestions.List {...props}>
      { useNamedSelector('activities.examples', { category: extra?.habitTypeId }).map(example =>
        <p key={example}>{example}</p>
      ) }
    </Suggestions.List>
  );
}
